import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, tap } from 'rxjs/operators';

@Component({
  selector: 'val-dt-search',
  template: ` <div class="dt-filter dt-search">
    <input type="text" class="form-control" [placeholder]="placeholder" #input />
    <i class="material-icons-outlined">search</i>
  </div>`,
  styleUrls: ['../../../../../assets/styles/shared/dt-filters.scss'],
})
export class DtSearchComponent implements OnInit {
  @Input() placeholder: string;
  @Output() onFilter = new EventEmitter<string>();
  @ViewChild('input') input: ElementRef;

  constructor() {}

  ngOnInit(): void {
    if (!this.placeholder) {
      this.placeholder = 'Search within results';
    }
  }

  ngAfterViewInit() {
    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        filter(Boolean),
        debounceTime(500),
        distinctUntilChanged(),
        tap((text) => {
          this.onFilter.emit(this.input.nativeElement.value.toLowerCase());
        })
      )
      .subscribe();
  }
}
